module.exports = __webpack_public_path__ + "img/logoMucap.c891abe1.png";